import logoUrl from '@/assets/branding/logo.jpg';
import secondaryLogoUrl from '@/assets/branding/logo-secondary.jpeg';

import type { ChatBranding } from './types';

export const defaultBranding: ChatBranding = {
  logo: logoUrl,
  secondaryLogo: secondaryLogoUrl,
  title: 'Assistente Cidadão',
  subtitle: 'SEPLAG - Avalia Gov.MT',
  inputPlaceholder: 'Digite sua pergunta sobre programas governamentais...',
  welcomeMessage:
    'Olá, tudo bem? Sou o Assistente Cidadão, do Avalia **[Gov.MT](https://portal.mt.gov.br/)**. Posso te ajudar com informações sobre os principais resultados alcançados pelo Governo de Mato Grosso no último ano? O que gostaria de saber?',
  errorMessage: 'Desculpe, não consegui responder agora. Tente novamente em alguns instantes.',
  charLimit: 500,
  launcherTooltipMaxLength: 60,
  fontFamily: "'Roboto Variable', Roboto, Arial, Helvetica, sans-serif",
};
